import { Col, Row, Tabs } from "antd";
import { Jurados } from "./jurados.view";
import { Proyectos } from "./proyectos.view";
import "./style.scss";

export const SeguimientoProyectos = () => {
  return <Proyectos />;
};
